import React from "react";
import "./style.css";
import useStatus from "../../../hooks/useStatus";
const EnvironmentStatusBar = () => {
  const { status, devActive, stageActive } = useStatus();
  const statusClass = devActive
    ? "statusbar--dev"
    : stageActive
    ? "statusbar--staging"
    : "";
  return status && <div className={`statusbar ${statusClass}`}></div>;
};

export default EnvironmentStatusBar;
